<template>
  <v-container fluid>
    <v-card class="mb-4">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('demandProfiles.listTitle')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          :label="$t('general.search')"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-card-title>
      <data-table
        :items="formatedDemandProfilesList"
        :headers="$store.getters['demandProfiles/headers']"
        :loading="$store.state.demandProfiles.loading"
        :search="search"
        :selectAll="user.role > 2"
        @selected="(value) => selected = value"
        @edit="editSelection"
      ></data-table>
    </v-card>
    <v-fab-transition>
      <v-btn v-if="showAddButton && user.role > 2" fab dark color="primary" bottom right fixed @click.native="editMode = 'add'; editDialog = true">
        <v-icon dark>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-fab-transition>
      <v-btn
        fab
        dark
        color="red"
        bottom
        right
        fixed
        @click.native="deleteDialog = true"
        style="right: 80px;"
        v-if="selected.length > 0"
        >
        <v-icon dark>delete</v-icon>
      </v-btn>
    </v-fab-transition>
    <demand-profile-edit :mode="editMode" :active="editDialog" :id="demandProfilId" @closedialog="editDialog = false; demandProfilId = null"></demand-profile-edit>
    <confirmation-dialog :active="deleteDialog" title="Confirmation ?" :message="$tc('demandProfiles.deleteConfirmation', selected.length, {count: selected.length})" :loading="$store.state.demandProfiles.loading" @confirmation="deleteDemandProfile" @cancel="deleteDialog = false"></confirmation-dialog>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import DataTable from "@/components/DataTable";
import DemandProfileEdit from "./DemandProfile-edit"
import ConfirmationDialog from "@/components/ConfirmationDialog"
export default {
  name: "DemandProfiles",
  components: {
    DataTable,
    DemandProfileEdit,
    ConfirmationDialog
  },
  data() {
    return {
      showAddButton: false,
      search: "",
      selected: [],
      editDialog: false,
      deleteDialog: false,
      demandProfilId: "",
      editMode: "add"
    };
  },
  mounted() {
    this.$store.dispatch("demandProfiles/getAll");
    setTimeout(() => this.showAddButton = true, 500)
  },
  methods: {
    editSelection(value) {
      this.editMode = 'edit'
      this.demandProfilId = value
      this.editDialog = true
    },
    async deleteDemandProfile() {
      if (await this.$store.dispatch("demandProfiles/delete", this.selected.map(item => item._id))){
        this.deleteDialog = false
        this.selected = []
      }
    }
  },
  computed: {
    formatedDemandProfilesList () {
      return this.$store.state.demandProfiles.list.map(profile => {
        profile.typeName = this.$store.getters['demandProfiles/type'][profile.type - 1].name
        return profile 
      })
    },

    ...mapGetters('user', {
      user: 'current'
    })
  }
};
</script>
